import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full flex-col gap-7.5',
    label: 'relative top-[2px] hidden lg:flex',
    top: 'flex flex-col gap-6',
    header: 'flex items-center justify-between',
    headerAmount: 'mt-0 flex items-center justify-between',
    tabTitle: 'flex items-center justify-center gap-1',
    title: 'heading-2xl mt-0 font-[450]',

    totals: 'flex flex-col gap-4',
    grandTotal: 'flex items-baseline justify-between',
    grandTotalLabel:
      'heading-s-intr-bold !font-[450] tracking-[0.06em] uppercase',
    grandTotalPrice: 'flex items-baseline',

    button: 'mt-6 w-full',

    characteristic: 'flex w-full max-w-screen flex-col gap-3',
    characteristicLabel:
      'heading-xs lg:heading-s text-bg-items-black flex grow items-baseline whitespace-nowrap after:mx-3 after:block after:h-[4px] after:w-full after:bg-[linear-gradient(90deg,#747d81_0%,#747d81_33.33%,transparent_33.33%,transparent_100%)] after:[background-size:6px_1px] after:bg-bottom after:bg-repeat-x',
    characteristicValue:
      'heading-s-intr-regular text-bg-items-black max-w-[60%] font-[450]',
    characteristicItem: '!md:py-0 !border-b-[0px] !py-0',
    yaSplitBadge: 'mt-0 lg:mt-0',
    productWrapper: '',
    productItem: '',
    productImage: '',
    productCount: '',
    productLeftCount: '',
    tab: 'text-s hover:bg-brand-400 h-11.5 w-1/2 rounded-none border-0 font-medium normal-case hover:[&_svg:nth-of-type(1)]:hidden [&_svg:nth-of-type(2)]:hidden hover:[&_svg:nth-of-type(2)]:block',
    tabs: 'rounded-none',
    activeTab:
      'bg-brand-400 text-text-main-inversion [&_svg:nth-of-type(1)]:hidden [&_svg:nth-of-type(2)]:block',
    tabsWrap: 'gap-1 bg-white p-2',
    bonusIcon: 'h-5 w-5'
  },
  variants: {
    variant: {
      checkout: {
        yaSplitBadge:
          'bg-system-gray-100 w-full rounded-[20px] px-[16px] py-[15px]',
        productWrapper: 'flex gap-[8px]',
        productItem: 'relative hover:cursor-pointer',
        productImage: 'h-[96px] w-[96px]',
        productCount:
          'bg-brand-400 absolute bottom-[4px] left-[4px] flex max-h-[16px] items-center justify-center rounded-[100px] px-[6px] py-[0.5px] text-[12px] leading-[140%] text-white',
        productLeftCount:
          'bg-brand-100 text-items-black flex h-[96px] w-[96px] items-center justify-center text-2xl leading-[120%] font-semibold',
        grandTotalLabel: 'text-s text-semibold trading-[0.06] leading-[120%]',
        grandTotalPrice:
          'text-semibold text-bg-items-black text-2xl leading-[120%]'
      },
      cartDrawer: {
        grandTotalLabel:
          'heading-s-intr-bold !font-[450] tracking-[0.06em] uppercase',
        grandTotalPrice: 'flex items-baseline'
      }
    }
  }
});
